import React from 'react';
import { observer } from 'mobx-react-lite';
import Fade from '@material-ui/core/Fade';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import { useRootStore } from '../../../../mobx/bridge';
import styles from './LoadingScreen.module.css';
import commonStyles from '../../../../assets/stylesheets/common.module.css';
import connectSMSLogo from '../../../../assets/images/connect-chat-logo.svg';
import * as utils from '../../../../helpers/utils';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const LoadingScreen = observer(function LoadingScreen() {
  const { commonStore } = useRootStore();
  const { t } = useTranslation();

  function logoutButtonClickHandler() {
    commonStore.setLogoutStatus(true);
  }

  return (
    <Fade
      in={!commonStore.isDataLoaded}
      timeout={commonStore.isDataLoaded ? 1000 : 0}
      unmountOnExit
    >
      <Grid
        component="div"
        item
        className={styles.loadingScreenHolder}
        data-testid="loadingScreenContainer"
      >
        <Grid component="div" container>
          <Grid component="div" item xs={12} align="center">
            {!commonStore.cpHeaderHeight && !utils.inIframe() ? (
              <button
                type="button"
                onClick={logoutButtonClickHandler}
                className={styles.closeBtn}
              />
            ) : null}

            <img src={connectSMSLogo} alt="logo" className={commonStyles.connectSMSLogo} />

            <div className={commonStyles.spinner}>
              <div className={commonStyles.bounce1} />

              <div className={commonStyles.bounce2} />

              <div className={commonStyles.bounce3} />
            </div>

            <h1 className={styles.loadingScreenMessage}>{t('Common.Loading')}</h1>
          </Grid>
        </Grid>
      </Grid>
    </Fade>
  );
});
LoadingScreen.whyDidYouRender = true;
LoadingScreen.displayName = 'LoadingScreen';

export default LoadingScreen;
